import { render, staticRenderFns } from "./BindingFormDialog.vue?vue&type=template&id=646c0c28&scoped=true"
import script from "./BindingFormDialog.vue?vue&type=script&lang=js"
export * from "./BindingFormDialog.vue?vue&type=script&lang=js"
import style0 from "./BindingFormDialog.vue?vue&type=style&index=0&id=646c0c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c0c28",
  null
  
)

export default component.exports